/** Deterministic transforms that must run before an export snapshot is hashed. */

import { normalizeLogoSlots } from '../editing/logo-normalizer.js';

function normalizeSectionLogoHTML(section) {
  if (!section?.html || typeof DOMParser === 'undefined') return;
  const doc = new DOMParser().parseFromString(`<div>${section.html}</div>`, 'text/html');
  const root = doc.body.firstElementChild;
  if (root && normalizeLogoSlots(root)) section.html = root.innerHTML;
}

/**
 * Normalize every supported logo shape on the snapshot clone. This must run
 * before hashing: generators and saved preview already normalize the same
 * shapes, so hashing the pre-normalized source would let the reviewed hash and
 * the shipped artifact disagree.
 */
export function normalizeExportLogoSlots(state) {
  if (state?.sharedSections?.navigation) normalizeSectionLogoHTML(state.sharedSections.navigation);
  if (state?.sharedSections?.footer) normalizeSectionLogoHTML(state.sharedSections.footer);
  for (const page of state?.pages || []) {
    for (const section of page.sections || []) normalizeSectionLogoHTML(section);
  }
}
